import { createModel } from "hox";
import React, { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { EditModeType, IPgProps, ISearchPage, OptionDsType } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { noticeService } from "../NoticeService";
import { IMdNoticeDetail, IMdNoticeFields } from "../NoticeTypes";
import { dictService } from "../../base/dict/DictService";
import { orgService } from "../../base/org/OrgService";
import { ITreeData } from "@src/components/YhFormBox/Types";
import { trasDsToTreeData } from "../../base/dict/dictModel";
import { globalPrompt } from "@src/components/YhMessage";
import useGlobalModel from "@src/model/globalModel";

export function transPgToPagination(pg: IPgProps): PaginationProps {
  return {
    total: pg.total,
    pageSize: pg.size,
    current: pg.current
  }
}


function useModel() {
  const { user } = useGlobalModel()
  const initSearchParam: IMdNoticeFields = {};
  const initDataSource: IMdNoticeDetail[] = [];
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

  //查询条件
  const [searchParam, setSearchParam] = useState<IMdNoticeFields>(initSearchParam);
  //列表数据源
  const [dataSource, setDataSource] = useState<IMdNoticeDetail[]>(initDataSource);
  //表格选中行Key值
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRowData, setSelectedRowData] = useState<IMdNoticeFields>();
  const [previewData, setPreviewData] = useState<IMdNoticeFields>();
  const [previewDisabled, setPreviewDisabled] = useState<boolean>();
  //列表数据源分页参数

  const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

  /** Drawer */
  const [drawerVisible, setDrawerVisible] = useState(false);

  const [editModel, setEditModel] = useState<EditModeType>("add")

  const [resetState, setResetState] = useState(false)

  const [noticeTypeDs, setNoticeTypeDs] = useState<OptionDsType[]>()
  const [orgDs, setOrgDs] = useState<ITreeData[]>()


  const [loading, setLoading] = useState(true)

  const getDs = async () => {
    try {
      let noticeDs = await dictService.oneTreeDs({ code: "notice-type" })
      let orgDs = await orgService.orgTreeDs({})
      // let { retData } = await noticeService.findOrgTree()
      // let orgds = trasDsToTreeData(retData, "code", "name");
      setNoticeTypeDs(noticeDs)
      setOrgDs(orgDs)
    } catch (error) {

    }
  }

  const onSearch = () => {
    loadData({ pageNum: 1 }).then()
  }
  const onReset = () => {
    resetSearchParam()
    setResetState(!resetState)
  }

  const updatePgCfg = (updateParam: TablePaginationConfig) => {
    setPgCfg({ ...pgCfg, ...updateParam })
  }
  const updateSearchParam = (updateParam: IMdNoticeFields) => {
    setSearchParam({ ...searchParam, ...updateParam })
  }
  const resetSearchParam = () => {
    setSearchParam(initSearchParam);
  }

  const loadData = async (page?: ISearchPage, searchValue: IMdNoticeFields = searchParam) => {
    setLoading(true)
    try {
      const searchParams = {
        ...searchValue,
        page: {
          // orders: [{
          //     asc: true,

          //     column: ""
          // }],
          pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
          pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
      }
      let { retData } = await noticeService.page(searchParams);
      setLoading(false)
      const { records, ...pg } = retData;
      setPgCfg(transPgToPagination(pg));
      setDataSource(records);
    } catch (error) {
      globalPrompt("message", { type: "error", text: "数据请求失败！" })
      setLoading(false)
    }
  }

  const cancleNotice = async (id: string) => {
    try {
      const { success, retMsg } = await noticeService.cancel(id)
      globalPrompt('message', { text: retMsg, type: success ? 'success' : 'warning' })
      if (success) {
        loadData().then()
      }
    } catch (error) {

    }
  }

  const readNotice = async (id: string) => {
    try {
      const { userCode } = user
      const { retMsg, success } = await noticeService.readNotice(id, userCode as string)
    } catch (error) {
      console.log(error)
    }
  }
  return {
    /***field***/
    searchParam,
    dataSource,
    selectedRowKeys,
    selectedRowData,
    pgCfg,
    drawerVisible,
    resetState,
    editModel,
    noticeTypeDs,
    orgDs,
    previewData,
    previewDisabled,
    loading,

    /***method***/
    setDataSource,
    setSelectedRowKeys,
    setSelectedRowData,
    resetSearchParam,
    updateSearchParam,
    loadData,
    updatePgCfg,
    setDrawerVisible,
    onSearch,
    onReset,
    setEditModel,
    getDs,
    cancleNotice,
    setPreviewData,
    setPreviewDisabled,
    readNotice,
  }

}


export const useNoticeModel = createModel(useModel);